import './HoursChart.css'

import PropTypes from 'prop-types'
import React from 'react'

function HoursChart({ data, fromHour, legend, toHour }) {
  function getColorByValue(value) {
    const lastIndex = legend.length - 1
    const { color } = legend.find(
      ({ min, max }, index) => !value || value < 0 || (value >= min && value <= max) || index === lastIndex,
    )

    return color
  }
  const itemsCount = data.length

  return (
    <div className="hours-chart">
      {Array.from({ length: toHour - fromHour + 1 }, (_, index) =>
        data.map(({ countryId, revenuePerHour }, countryIndex) => {
          const { value } = revenuePerHour[fromHour + index]
          const background = getColorByValue(value)
          const firstStyles = countryIndex % itemsCount === 0 ? { borderBottomLeftRadius: '2px', borderTopLeftRadius: '2px' } : {}
          const lastStyles =
            ((countryIndex + 1) / itemsCount) % 1 === 0 ? { borderBottomRightRadius: '2px', borderTopRightRadius: '2px' } : {}

          return (
            <div
              className="hours-chart-bar"
              key={`${countryId}-${index}-${countryIndex}`}
              style={{
                background,
                flexBasis: `calc(${Math.floor(100 / itemsCount)}% - 1px)`,
                ...firstStyles,
                ...lastStyles,
              }}
            />
          )
        }),
      )}
    </div>
  )
}

HoursChart.defaultProps = {
  fromHour: 0,
  toHour: 23,
}

HoursChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      countryId: PropTypes.string,
      revenuePerHour: PropTypes.arrayOf(
        PropTypes.shape({
          hour: PropTypes.number.isRequired,
          value: PropTypes.number,
        }),
      ).isRequired,
    }),
  ).isRequired,
  fromHour: PropTypes.number,
  legend: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
      max: PropTypes.number,
      min: PropTypes.number.isRequired,
    }),
  ).isRequired,
  toHour: PropTypes.number,
}

export default HoursChart
